<div class="d-flex align-items-center gap-2">
  @if (content) {
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <div class="panel-header-wrapper">
            <div
              class="panel-header-content"
              [ngClass]="{ ellipsis: content.length > 54 }"
            >
              <p [innerHTML]="content"></p>
            </div>
          </div>
        </mat-expansion-panel-header>
        <markdown-editor
          [(value)]="content"
          [noPreview]="true"
          [disabled]="true"
          [showMenu]="showMenu"
        ></markdown-editor>
      </mat-expansion-panel>
    </mat-accordion>
  }
  @if (!content) {
    <span>—</span>
  }
</div>
